<template>
	<div class="isMerge_turn" v-if="isMergeTurn">
		<div class="fail_box">
			<img src="@comm/images/document-conversion/upload_pdf.svg" alt="" v-if="MergeData.fileType == 'pdf' || MergeData.fileType == 'PDF'" />
			<img src="@comm/images/document-conversion/upload_ofd.png" alt="" v-if="MergeData.fileType == 'ofd' || MergeData.fileType == 'OFD'" />
			<a :title="MergeData.fileName + '.' + MergeData.fileType">{{ MergeData.fileName.length > 15 ? MergeData.slname : MergeData.fileName }}{{ "." + MergeData.fileType }}</a>
		</div>
		<div class="button_box">
			<el-button @click="readApi">预览</el-button>
			<el-button class="downZip" @click="downdBtn" :disabled="isDowning" :class="{ disable: isDowning }">
				<div v-if="!isDowning">下载</div>
				<div v-else>
					<i class="downing_icon"></i>
					下载
				</div>
			</el-button>
		</div>
	</div>
</template>

<script>
import Files from "@comm/utils/files";
import { downloadUploadFile } from "@comm/api/document-conversion";
import { buriedPoint } from "@comm/utils/buryingPoint.js";
import { getUserInfo } from "@comm/utils/auth";
export default {
	name: "mergeTurn",
	props: {
		MergeTurnData: "",
		isMergeTurnData: false
	},
	data() {
		return {
			isMergeTurn: this.isMergeTurnData,
			MergeData: this.MergeTurnData,
			downTime: "",
			isDowning: false,
			APIPort: process.env.APIPort
		};
	},
	created() {},
	watch: {
		MergeTurnData(val) {
			this.MergeData = val;
		},
		isMergeTurnData(val) {
			this.isMergeTurn = val;
		}
	},
	methods: {
		// 预览
		readApi() {
			let userInfo = JSON.parse(getUserInfo())
			let nickname = encodeURIComponent(encodeURIComponent(userInfo.nickname))
				const { href } = this.$router.resolve({
          path: `/r:${this.MergeData.shortUrl}&&${nickname}`
        });
        window.open(href, "_blank");
		},
		// 下载
		downdBtn() {
			if (this.isDowning) return;
			this.isDowning = true;
			let that = this;
			this.downTime = Date.parse(new Date());
			let data = {}
			data = {
					fileId: this.MergeData.fileIds,
					fileName: encodeURIComponent(this.MergeData.name + "." + (this.MergeData.turnFileType || this.MergeData.fileType))
				}
			downloadUploadFile(data)
				.then((res) => {
					this.downloadFile(2, res, this.MergeData);
				})
				.catch(() => {
					that.isDowning = false;
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
					if (this.APIPort == 8001) {
						let dictionaryId = 0;
						let downloadType = 0;
						let downloadFileType = 0;
						if (that.MergeData.fileType == "ofd") {
							dictionaryId = 88;
						} else {
							dictionaryId = 89;
						}
						let nowTime = Date.parse(new Date());
						let time = nowTime - that.downTime;
						setTimeout(function () {
							buriedPoint("isDown", dictionaryId, 1, downloadType, downloadFileType, time, that.MergeData.size);
						}, 200);
					}
				});
		},
		downloadFile(type, res, file) {
			let that = this;
			Files.downloadFile(type, res, file, (type, file) => {
				this.isDowning = false;
				that.$forceUpdate();
				if (this.APIPort == 8001) {
					let dictionaryId = 0;
					let downloadType = 0;
					let downloadFileType = 0;
					downloadType = 0;
					console.log(this.$route)
					if (this.$route.path == "/imgConversion/") {
						dictionaryId = 89;
					} else{
						if(this.$route.query.type=='ofdtopdf'){
							dictionaryId = 96;
						}else if(this.$route.query.type=='topdf'){
							dictionaryId = 111;
						}else{
							dictionaryId = 74;
						}
						
					}

					let nowTime = Date.parse(new Date());
					let time = nowTime - this.downTime;
					setTimeout(function () {
						buriedPoint("isDown", dictionaryId, 0, downloadType, downloadFileType, time, file.size);
					}, 200);
				}
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.fail_box {
	// margin-bottom: 32px;
	margin-top: 66px;
	a {
		padding-left: 12px;
		font-size: 16px;
		color: #242f44;
		line-height: 64px;
		height: 64px;
	}
}
.downZip {
	margin-left: 12px;

	&:hover {
		cursor: pointer;
		color: #15b2ff;
	}

	&:focus,
	&:active {
		color: #1299d9;
	}

	&.disable {
		color: #c0c4cc;
		position: relative;
	}
}
.isMerge_turn {
	height: 325px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.button_box {
		margin-top: 32px;
	}
	img {
		width: 64px;
	}

	span {
		font-size: 16px;
		color: #242f44;
		line-height: 64px;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/mergeTurn/index.vue